export default "__VITE_ASSET__6dd4d6b6__"